import React from 'react'
import "../components/HomeMarqueeText.css";

const HomeMarqueeText = () => {
  return (
    <section className="home-marquee-text" id="marqueeText">
        <div className="marquee-wrapper">
            <div className="marquee">
                <span className="text-white mr-3">The future </span> depends on <span className="text-white ml-3 mr-4">today.</span>

                {/* <span className="text-white mr-3">The future </span> depends on what you do <span className="text-white ml-3 mr-4">today.</span> */}
            {/* Tomorrow is shaped by today */}
            {/* <span className="font-bold">NEW</span> Tomorrow begins Today. */}
            </div>
       </div>
    </section>
  )
}

export default HomeMarqueeText
